import { render, staticRenderFns } from "./SCC.vue?vue&type=template&id=01af3be6&scoped=true&"
import script from "./SCC.vue?vue&type=script&lang=js&"
export * from "./SCC.vue?vue&type=script&lang=js&"
import style0 from "./SCC.vue?vue&type=style&index=0&id=01af3be6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01af3be6",
  null
  
)

export default component.exports